module.exports = __webpack_public_path__ + "img/26.a2e65f78.jpg";